module.exports = __webpack_public_path__ + "static/media/barbecue2.c191fa1f.jpg";